enum EntityImageThumbnailSizeEnum {
  Source = 1,
  Map120,
  Mobile130,
  Desktop150,
}

export default EntityImageThumbnailSizeEnum;
